import React, { CSSProperties, ReactNode } from "react";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import clsx from "clsx";
import { Placement } from "react-bootstrap/esm/types";
import Icon, { Sizes } from "./Icon";
import { Icons } from "./@types/icons";

type TooltipIconProps = {
  className?: string;
  icon: Icons;
  id?: string;
  message: ReactNode;
  placement?: Placement;
  style?: CSSProperties;
  onClick?: () => void;
  "data-testid"?: string;
  size?: Sizes;
  dimensions?: Sizes;
  tooltipClassName?: string;
};

const TooltipIcon: React.FC<TooltipIconProps> = ({
  className,
  id,
  icon,
  message,
  style,
  placement = "top",
  onClick,
  "data-testid": testId,
  size,
  dimensions,
  tooltipClassName
}) => (
  <OverlayTrigger
    overlay={
      <Tooltip id={id} className={tooltipClassName}>
        {message}
      </Tooltip>
    }
    placement={placement}
  >
    <div
      data-testid={`${testId || icon}_tooltip_icon`}
      style={style}
      className={clsx("d-inline-flex align-center fit-content", className)}
      onClick={onClick}
    >
      <Icon style={style} name={icon} size={size} dimensions={dimensions} />
    </div>
  </OverlayTrigger>
);

export default TooltipIcon;
